import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_e411w_07
 * @category 고장분석현황[전체] - 고장요인별
 */

export class BreakFactorsModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   *  호기명
   *
   * **data type** varchar(?)
   */
  readonly equpnm : string;

  /**
   *  현장코드
   *
   * **data type** varchar(?)
   */
  readonly actcd : string;

  /**
   *  현장명
   *
   * **data type** varchar(?)
   */
  readonly actnm : string;

  /**
   *  고장요인
   *
   * **data type** varchar(?)
   */
  readonly remonm : string;

  /**
   *  고장건수
   *
   * **data type** varchar(?)
   */
  readonly tot: string;


  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.equpnm = data.equpnm || '';
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.remonm = data.remonm || '';
    this.tot = data.tot || '';


    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
